<template>
    <div class="col-md-3">
   <section v-if="link">
        <a  :href="linkWithRedirect" target="_blank">
            <div class="flip-card">
                <div class="flip-card-inner">
                    <div class="flip-card-front">
                        <h1>{{ name }}</h1>
                    </div>
                    <div class="flip-card-back">
                        <h1>{{ linkWithRedirect }}</h1>
                        <p>{{ name }}</p>
                            <button  class="btn ce-btn-link">Go to Website</button>
                    </div>
                </div>
            </div>
        </a>
        </section>
    </div>
</template>
<script>
    export default {
        props: ['name','link','clientId'],
         computed: {
            linkWithRedirect() {
                if (!this.link) return '';
                // Check if link already has query params
                return this.link.includes('?')
                    ? `${this.link}&redirect=admin`
                    : `${this.link}?redirect=admin`;
            }
        },
        data() {
            return {
              isAllowed:10
            }
        },
    }

</script>
